<!-- Esquema con estilos de color para dominios y leyenda de tipos, y detalles visuales en nodos -->
<div class="network-graph-root">
  <div class="network-graph-sidebar">
    <div class="filter-grid">
      <div class="filter-row filter-row-domains">
        <h4 class="network-graph-sidebar-title">
          {{ translate('documents.domains') }}
          <span class="domain-count">{{ visibleDomains.length }}</span>
        </h4>
        <input type="search" class="domain-search" id="network-domain-search"
               [value]="domainQuery"
               (input)="onDomainQueryChange($any($event.target).value)"
               [attr.placeholder]="translate('documents.search_domain')"
               [attr.aria-label]="translate('documents.search_domain')">
        <div class="domain-chip-grid">
          <span *ngFor="let domain of visibleDomains"
                (click)="onDomainFilterClick(domain)"
                class="network-graph-domain-chip"
                [class.selected]="selectedDomain === domain"
                [style.background]="domainColors[domain]"
                [title]="domain">
            {{ domain }}
          </span>
        </div>
        <p *ngIf="visibleDomains.length === 0" class="domain-empty">
          {{ translate('documents.no_domain_results') }}
        </p>
        <span *ngIf="selectedDomain" (click)="resetPieChart()" class="network-graph-domain-chip clear">{{ translate('documents.clear_filter') }}</span>
      </div>
      <div class="filter-row filter-row-subdomains" *ngIf="selectedDomain && !selectedSubdomain">
        <h4>{{ translate('documents.subdomains') }}</h4>
        <div>
          <span *ngFor="let sub of subdomains"
                (click)="onSubdomainFilterClick(sub)"
                class="network-graph-domain-chip"
                [style.background]="subdomainColors[sub]">
            {{ sub }}
          </span>
          <span (click)="resetPieChart()" class="network-graph-domain-chip clear">{{ translate('documents.back') }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="network-graph-main">
    <div *ngIf="!selectedDomain">
      <div class="pie-details-text">
        <h2>{{ translate('documents.domain_distribution') }}</h2>
        <p>{{ translate('documents.select_domain_hint') }}</p>
      </div>
      <div echarts [options]="chartOptions" (chartInit)="onChartInit($event)" class="donut-chart xlarge"></div>
    </div>
    <div *ngIf="selectedDomain && !selectedSubdomain" class="subdomain-pie-container">
      <div class="subdomain-pie">
        <div class="pie-details-text">
          <h2>{{ translate('documents.subdomain_distribution', { domain: selectedDomain }) }}</h2>
          <p>{{ translate('documents.select_subdomain_hint') }}</p>
        </div>
        <div echarts [options]="subdomainChartOptions" (chartInit)="onSubdomainChartInit($event)" class="donut-chart xlarge"></div>
      </div>
    </div>
    <div *ngIf="selectedDomain && selectedSubdomain">
      <div class="network-graph-legend">{{ translate('documents.redirecting_to_details') }}</div>
    </div>
  </div>
</div>
